"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgClearFilter = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("g", __assign({ clipPath: "url(#clear-filter_svg__clip0_2508_21363)" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M14.837 11.86l-1.004-1.005 4.272-5.424H8.416l-1.4-1.402h12.303c.327 0 .568.148.724.444.155.296.124.576-.094.841l-5.112 6.546zm-.467 3.53v2.665c0 .265-.09.487-.269.666a.903.903 0 01-.665.269h-1.868a.903.903 0 01-.665-.27.905.905 0 01-.269-.665v-6.406L3.21 4.216A.686.686 0 013 3.713c0-.195.07-.362.21-.503.14-.14.308-.21.502-.21.195 0 .362.07.502.21L20.79 19.808c.14.14.21.304.21.49 0 .188-.07.351-.21.492a.685.685 0 01-.502.21.684.684 0 01-.502-.21l-5.416-5.4z" }) })) }))); };
exports.default = SvgClearFilter;
